export default {
    ca: {
        title: 'Duplicar mapa',
    },
    es: {
        title: 'Duplicar mapa',
    },
    en: {
        title: 'Duplicate map',
    },
};



// WEBPACK FOOTER //
// ./src/shared/components/thumbnailmap/thumnailmap-translations.js